import { TrueOrFalseFormFields } from '@/components/question/forms/true-or-false/TrueOrFalseForm';
import { trueOrFalseQuestionGenerator } from '@/data/generators/trueOrFalseQuestionGenerator';
import { QuestionTypeEnum, TrueOrFalseQuestion } from '@/models/Question';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export default function adapterTrueOrFalseForm(
  trueOrFalse: TrueOrFalseFormFields,
): TrueOrFalseQuestion {
  return trueOrFalseQuestionGenerator({
    title: normalizeTranslatableField(trueOrFalse.title),
    context: normalizeTranslatableField(trueOrFalse.context),
    type: QuestionTypeEnum.TRUE_OR_FALSE,
    isTrue: trueOrFalse.isTrue,
  });
}
